import { CssSelector } from "@angular/compiler";
import { Component } from "@angular/core";
import { TslOverlayRef } from "@tesla/ng-tds";

@Component({
    template: 
    `<div style="display: block; width:auto; margin-left:20px;">
     <h3 style="padding-top: 5px; padding-bottom: 0px; margin: 0px;">  口座名義人  入力上の注意事項 </h3>
     <ul style="padding: 5px; padding-top: 0px; margin-top: 5px; margin-left: 20px;">
        <li>口座名義人の入力は、すべて半角カナ（半角英数字も利用可）で入力してください。</li>
        <li>小文字（ｧ､ｨ､ｪ､ｯ､ｬ､ｭ､ｮ 等）は利用せず、大文字で入力してください。</li>
        <li>アルファベットでの口座名義人の登録させている場合は、半角・大文字で入力してください。</li>
        <li>屋号（会社名）と個人名（代表者名）の間や、姓と名の間には、半角スペースを入れてください。</li>
        <li>スペースを入力する場合は、半角で入力してください。</li>
        <li>中グロ「・」は使用できません。 ピリオド「.」で入力してください。</li>
     </ul>
     </div>`,
})

export class BankPopoverKatanakaContent {

    constructor(
        private overlayRef: TslOverlayRef<BankPopoverKatanakaContent>
    ) { }

    close() {
        this.overlayRef.close();
    }
}
